function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M383.419 16.2918C388.238 9.5019 392.853 3 403 3V0C391.331 0 386.228 7.45966 381.042 15.0386L381 15.1C376.1 22 371.2 28.9 361 28.9H42.6001C32.3001 28.9 27.5001 22 22.6001 15.1C17.3001 7.5 11.7 0 0 0V3C10.5 3 15 10 20.2 17C26 25 31 32.5 42.6001 32H361C372.7 32 377.9 24.1 383.2 16.6L383.419 16.2918Z",
  fill: "#FFCC00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42 28.8718C31.9999 28.6858 27.8 22.5 22.8 15.5C17.8 8.5 12.5 0.500051 0.5 5.14984e-05L403.5 0C389.5 -5.14982e-05 384.4 11.4999 381.2 15.4999C378 19.4999 373 28.4999 362.5 28.8718H42Z",
  fill: "#5A5A5A",
  fillOpacity: 0.42,
  id: "svg-top-line-bg"
});

var SvgTopLine = function SvgTopLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 33,
    viewBox: "0 0 404 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/top-line.7473f17d.svg";
export { ForwardRef as ReactComponent };